import ourPraiseBg from "../assets/our_praise_bg.png";
import digitalRenterBg from "../assets/digitalRenterBg.webp";
import digitalRenterWebBg from "../assets/digitalRenterWebBg.png";
import nkwaBg from "../assets/nkwaBg.webp";
import aiimeBg from "../assets/aiimeBg.webp";
import aiimeWebBg from "../assets/aiimeWebBg.png";
import cocartingBg from "../assets/cocartingBg.webp";
import buda6Bg from "../assets/buda6Bg.webp";
import sevenLanguagesBg from "../assets/sevenLanguagesBg.png";
import nkwaWebBg from "../assets/nkwaWebBg.png";
import cocartingWebBg from "../assets/cocartingWebBg.png";
import gameDevBg from "../assets/gameDevBg.jpg";
import { tagsEnum } from "./tags";

export const portfolioProjects = [
  {
    _id: "65dd251771487ae5b88dcfcb",
    title: "Our Praise Mobile App iOS",
    tag: tagsEnum.REACT_NATIVE,
    cover: ourPraiseBg,
    description: "View hymns, music sheets and audio of songs",
    liveLink: "https://apps.apple.com/cm/app/ourpraise/id6502869312",
  },

  {
    _id: "proj_cocarting_ios",
    title: "Cocarting iOS App",
    tag: tagsEnum.REACT_NATIVE,
    cover: cocartingBg,
    description: "Gift registry and wishlist management app for iOS users",
    liveLink:
      "https://apps.apple.com/us/app/wishlist-app-gift-register/id6670493695",
  },


  {
    _id: "proj_nkwa_android",
    title: "Nkwa (Oyesavings) Android App",
    tag: tagsEnum.REACT_NATIVE,
    cover: nkwaBg,
    description:
      "Android savings app for financial planning and money management",
    liveLink:
      "https://play.google.com/store/apps/details?id=com.maealth.oyesavings",
  },
 {
    _id: "proj_aiime_web",
    title: "Aiime Website",
    tag: tagsEnum.NEXT_JS,
    cover: aiimeWebBg,
    description:
      "Official website for Aiime, providing financial tools and product information",
    liveLink: "https://www.aiime.com/",
  },
  {
    _id: "proj_aiime_ios",
    title: "Aiime iOS App",
    tag: tagsEnum.REACT_NATIVE,
    cover: aiimeBg,
    description:
      "Smart personal finance app designed to help users manage money effortlessly",
    liveLink: "https://apps.apple.com/us/app/aiime/id1575792337",
  },
  {
    _id: "game_dev",
    title: "Game Projects",
    tag: tagsEnum.GAME_APPS,
    cover: gameDevBg,
    description:
      "Realistic open world racing game and 3D endless runner mobile games",
    liveLink: "https://drive.google.com/drive/folders/1sInqJwZorYgBTA5rgF5vqr3AvXcArtz3?usp=sharing",
  },
  {
    _id: "proj_digitalrenter_ios",
    title: "Digital Renter iOS App",
    tag: tagsEnum.REACT_NATIVE,
    cover: digitalRenterBg,
    description:
      "iOS rental platform for discovering and managing property listings",
    liveLink: "https://apps.apple.com/app/id1581265203",
  },

  {
    _id: "proj_nkwa_web",
    title: "Nkwa Website",
    tag: tagsEnum.NEXT_JS,
    cover: nkwaWebBg,
    description:
      "Web financial platform providing savings tools and financial insights",
    liveLink: "https://mynkwa.com/",
  },
  {
    _id: "proj_digitalrenter_android",
    title: "Digital Renter Android App",
    tag: tagsEnum.REACT_NATIVE,
    cover: digitalRenterBg,
    description:
      "Find houses for rent, manage listings, and explore property options on Android",
    liveLink: "https://play.google.com/store/apps/details?id=com.digitalrenter",
  },

  {
    _id: "proj_cocarting_android",
    title: "Cocarting Android App",
    tag: tagsEnum.REACT_NATIVE,
    cover: cocartingBg,
    description:
      "Android wishlist and gift registry app for sharing and managing gift lists",
    liveLink:
      "https://play.google.com/store/apps/details?id=com.cocarting&hl=en",
  },

  {
    _id: "proj_7000_languages_web",
    title: "7000 Languages Website",
    tag: tagsEnum.REACT_JS,
    cover: sevenLanguagesBg,
    description:
      "Website for the 7000 Languages project supporting global language learning",
    liveLink: "https://7000.org/",
  },


  {
    _id: "proj_cocarting_web",
    title: "Cocarting Website",
    tag: tagsEnum.REACT_JS,
    cover: cocartingWebBg,
    description:
      "Web platform for managing wishlists, gift registries, and shared gift ideas",
    liveLink: "https://cocarting.com/",
  },
  {
    _id: "proj_digitalrenter_web",
    title: "Digital Renter Website",
    tag: tagsEnum.NEXT_JS,
    cover: digitalRenterWebBg,
    description: "Property rental and management platform available on the web",
    liveLink: "https://digitalrenter.com/",
  },
 
  {
    _id: "proj_buda6_web",
    title: "Buda6 Website",
    tag: tagsEnum.REACT_JS,
    cover: buda6Bg,
    description:
      "Official website for Buda6, providing product and company information",
    liveLink: "https://buda6.com/",
  },
];
